import { AnalyticsEvent } from "./analyticsEvent"
class AnchorListInteractionEvent extends AnalyticsEvent {
    public anchorName: string;
    public interaction: string;
    constructor(anchorName: string, interaction: string) {
        super();
        this.anchorName = anchorName;
        this.interaction = interaction;
    }
}
export { AnchorListInteractionEvent }